import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import * as Languages from '../constants/Languages';
import getLangLocale from 'I18n/utils/getLangLocale';
export const getPreferredLanguage = () => {
  const navigator = window.navigator;
  const preferredLanguage = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '';
  return preferredLanguage;
};
export const getI18nLanguage = () => {
  // @ts-expect-error dependency missing types
  const lang = I18n.loaded && I18n.locale ? getLang() : Languages.EN;
  return lang;
};
export const getI18nLangLocale = () => {
  const langLocale =
  // @ts-expect-error dependency missing types
  I18n.loaded && I18n.locale ? getLangLocale() : `${Languages.EN}-us`;
  return langLocale;
};
export const I18nLookup = val => {
  // @ts-expect-error dependency missing types
  return I18n.lookup(val);
};

/**
 * Finds the first valid I18n key provided in keys param
 *
 * @param keys - Array of i18n keys
 */
export const findValidI18nKey = keys => {
  // @ts-expect-error dependency missing types
  return keys.find(key => I18n.lookup(key));
};